// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadExcelData_button__2k9XN","inlineLoader":"UploadExcelData_inlineLoader__2cZTC","hiddenInput":"UploadExcelData_hiddenInput__3LAuu"};